module.exports = __webpack_public_path__ + "media/images/not-found-5a6a89db.png";